import React from "react"
import { Navigate } from "react-router-dom"
import { route, routes } from "~/helpers/routeHelper"
import { useAuth } from "~/context/auth"
import ExternalRedirect from "~/components/Shared/ExternalRedirect"
import { getSsoAppUrl } from "~/helpers/utilHelper"
import { useAccess } from "~/context/access"
import { useProfile } from "~/context/profile"

interface AuthmiddlewareProps {
  component: React.ComponentType<any>;
  componentProps?: any;
  layout: React.ComponentType<any>;
  isProtected: boolean;
  isSetupRoute?: boolean;
  isGlbaRoute?: boolean;
}

const Authmiddleware: React.FC<AuthmiddlewareProps> = ({
  component: Component,
  componentProps,
  layout: Layout,
  isProtected,
  isSetupRoute,
  isGlbaRoute
}) => {

  const { isLoggedIn } = useAuth();
  const { iAmNotaryType, getUserAppUrl } = useAccess();
  const { notary, isProfileSetupRequired, isGlbaRequired } = useProfile();

  if (isProtected && !isLoggedIn()) {
    // this route is protected and the user is not logged in
    // so redirect to login
    return <ExternalRedirect to={getSsoAppUrl(`login?ret=${encodeURIComponent(window.location.href)}`)} />
  } else if (isProtected && !iAmNotaryType()) {
    // this user type is not allowed access in this app
    // so redirect to his own app
    return <ExternalRedirect to={getUserAppUrl('') || ''} />
  } else if (!isProtected && isLoggedIn()) {
    // this route is public and the user is logged in
    // so redirect to homepage
    return <Navigate to={route(routes.home)} />
  } else if (isProfileSetupRequired() && !isSetupRoute) {
    // this user must complete profile setup immediately
    // and this route is not part of the payment setup flow
    // so redirect to payment setup flow
    if (!!notary?.termsAcceptedTs) {
      return <Navigate to={route(routes.setup_profile_billing)} />
    } else {
      return <Navigate to={route(routes.setup_profile_terms)} />
    }
  } else if (isGlbaRequired() && !isGlbaRoute && !isProfileSetupRequired()) {
    // this user must complete GLBA form if 30 days have passed
    // and this route is not part of the GLBA flow
    // so redirect to GLBA flow
    return <Navigate to={route(routes.glba_general_information)} />
  }
  return <Layout>
    <Component {...componentProps} />
  </Layout>
}

export default Authmiddleware;
